import React from 'react';

import {assert} from 'Asserts';
import {SchemaType} from 'constants/ModelTypeConstants';
import {TagSchemaSummaryWithFieldsGraphQL} from 'schemas/useTagSchemaSummariesWithFields';
import FormGroup from 'ui-library/bs/FormGroup';
import Label from 'ui-library/bs/Label';

import SchemaAndSchemaTypeSelector from './SchemaAndSchemaTypeSelector';

interface LookupFieldSchemaSelectorProps {
  tagSchema: TagSchemaSummaryWithFieldsGraphQL | null;
  schemaType: SchemaType;
  isSchemaTypeReadonly: boolean;
  tagSchemasById: Record<string, TagSchemaSummaryWithFieldsGraphQL>;
  onTagSchemaChanged: (tagSchema: TagSchemaSummaryWithFieldsGraphQL, schemaType: SchemaType) => void;
}

export function LookupFieldSchemaSelector(props: LookupFieldSchemaSelectorProps): JSX.Element | null {
  // eslint-disable-next-line global-require
  const TagSchemaSelector = require('schemas/shared/TagSchemaSelector').default;

  const handleSelectTagSchema = (tagSchema: TagSchemaSummaryWithFieldsGraphQL | null): void => {
    assert(tagSchema != null, 'TagSchemaSelector returned a null TagSchema');
    props.onTagSchemaChanged(tagSchema, props.schemaType);
  };

  return (
    <FormGroup>
      <Label>Sample schema</Label>
      {props.isSchemaTypeReadonly ? (
        <TagSchemaSelector
          selectedTagSchemaId={props.tagSchema ? props.tagSchema.id : ''}
          onChange={handleSelectTagSchema}
        />
      ) : (
        <SchemaAndSchemaTypeSelector
          tagSchemaId={props.tagSchema != null ? props.tagSchema.id : null}
          schemaType={props.schemaType}
          onChange={props.onTagSchemaChanged}
          tagSchemasById={props.tagSchemasById}
        />
      )}
    </FormGroup>
  );
}

export default LookupFieldSchemaSelector;
